import React, { useEffect, useState, useMemo } from 'react'
import { useRecoilState } from 'recoil'
// import {auth} from './firebase'
import {authState} from 'atoms'
// import {onAuthStateChanged } from "firebase/auth";
import { Amplify, Hub, Logger } from 'aws-amplify'
import Auth from '@aws-amplify/auth'
import { awsConfig } from 'config'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import SignInPage from 'pages/SignInPage'
import SignUpPage from 'pages/SignUpPage'
import Dashboard from 'pages/Dashboard';
import Protected from 'components/Protected'
import Loader from 'components/Loader'
import { library } from '@fortawesome/fontawesome-svg-core'
import {faCheck, faQuestion, faXmark, faChartLine, faChevronLeft, faAngleLeft, faCaretLeft, faFaceGrin, faFaceGrinBeam, faFaceGrinHearts, faFaceSmile, faFaceSmileWink, faTriangleExclamation, faBatteryQuarter, faBatteryHalf, faBatteryThreeQuarters, faBatteryFull, faStar, faPlay, faPause } from '@fortawesome/free-solid-svg-icons'
library.add(faCheck, faQuestion, faXmark, faChartLine, faChevronLeft, faAngleLeft, faCaretLeft, faFaceGrin, faFaceGrinBeam, faFaceGrinHearts, faFaceSmile, faFaceSmileWink, faTriangleExclamation, faBatteryQuarter, faBatteryHalf, faBatteryThreeQuarters, faBatteryFull, faStar, faPlay, faPause)

Amplify.configure(awsConfig)

function App({ options }) {
  const [ loggedInUser, setLoggedInUser ] = useRecoilState(authState)

  // useEffect(() => {
  //   onAuthStateChanged(auth, async (user) => {
  //     setLoggedInUser({ userEmail: user?.email || '' })
  //       if(auth.currentUser) {
  //         const getToken = async () => {
  //           var data = await Auth.currentSession()
  //           console.log(data)
  //           return data.idToken.jwtToken
  //         }
  //       }
  //     // if(auth.currentUser) {

  //     //   const token = await auth.currentUser.getIdToken()
  //     //   token && await fetch('http://localhost:8080/devices/', {headers:{
  //     //     'x-authorization': 'Bearer '+token
  //     //   }})
  //     // }
  //     setLoading(false)
  //   })
  // }, [])
  // let content = loggedInUser.userEmail ?
  //   <Dashboard /> :
  //   <SignInPage /> /*<SignInPage_OLD />*/
  // Hub.listen('auth', console.log)

  // function listenToAutoSignInEvent() {
  //   Hub.listen('auth', ({ payload }) => {
  //     const { event } = payload
  //     if (event === 'autoSignIn') {
  //       const user = payload.data
  //       console.log(user)
  //       // assign user
  //     } else if (event === 'autoSignIn_failure') {
  //       // redirect to sign in page
  //     }
  //   })
  // }
  // const [isSignedIn, setIsSignedIn] = useState(null)

  // const [state, setState] = useState({
  //   user: {},
  //   isSignedIn: false,
  // })

  const auth = useMemo(() => {
    Auth.configure(options)
    return Auth
  }, [])

  // useEffect(() => {
  //   auth
  //     .currentAuthenticatedUser()
  //     .then((user) => setLoggedInUser({ user: user || '' }))
  //     .catch(() => {})
  // }, [])

  useEffect(() => {
    console.log(loggedInUser)
  }, [loggedInUser])

  // const signin = () => {
  //   setIsSignedIn(true)
  // }

  // const signout = () => {
  //   setIsSignedIn(false)
  // }

  const [loading, setLoading] = useState(true)

  useEffect(() => {
      Hub.listen('auth', ({ payload: { event, data } }) => {
        switch (event) {
            case 'signIn':
                console.log('Event name -> ', event, data)
                // here is your name, email e.t.c.
                console.log(data.signInUserSession.idToken.payload);
                setLoggedInUser({ user: data || '' })

                console.log(loggedInUser)
                //window.location.href = '/dashboard'
                break
            case 'signOut':
                console.log('sign out')
                // this.setState({ user: null })
                break
            default:
                console.log('Unhandled use case - ' + event)
        }
      })
    // Auth.currentAuthenticatedUser({
    //   bypassCache: false, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    // })
    //   .then((user) => {
    //     console.log(user)
    //     //setLoggedInUser({ user: user || '' })
    //     //console.log(loggedInUser)
    //     //  setState(
    //     //   {
    //     //     user: {},
    //     //     isSignedIn: true
    //     //   }
    //     //)
    //     //console.log(loggedInUser)
    //   })
    //   .catch((err) => console.log(err))

    setLoading(false)
  }, [])

  return (
    // <div className="App">
    //   {/* {loading ? <Loader /> : content} */}
    // </div>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route
            path="/dashboard"
            element={
              <Protected isSignedIn={loggedInUser}>
                <Dashboard />
              </Protected>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App;
